import { useState, useEffect } from "react";
import { Listbox, ListboxItem } from "@heroui/listbox";
import { useSession, useUser } from "@clerk/clerk-react";
import { Avatar } from "@heroui/avatar";
import { getMyConnections as getUserMembersApi } from "@/api/users";

const MeetsMembersComp = ({_members}) => {
const { session } = useSession();
const { user } = useUser();

const [connections, setConnections] = useState([])
const [participants, setParticipants] = useState([])

useEffect(() => {
    getMyConnections()
}, [_members])

useEffect(() => {
    buildParticipants()
}, [connections])

async function getMyConnections(){
    const token = await session.getToken();
    getUserMembersApi(token).then((_resp) => {
        if(_resp.data.Result === 'OK'){
            setConnections(_resp.data.Records)
        }
    }).catch((_resp) => {
        console.error(_resp)
    })
}

function buildParticipants(){
    const my_user_id = user['id']
    let tmp_arr = []
    for(const i in _members){
        const tmp_mem = _members[i]
        if(tmp_mem['member_id'] === my_user_id){
            continue
        }
        let user = connections.find(x => x['id'] === tmp_mem['member_id'])
        if(user === undefined){
            user = {
                'email_address':  "Account Removed",
                'fullname' : tmp_mem['member_email'],
                'id' : tmp_mem['member_id']
            }
        }
        tmp_arr.push(user)
    }
    setParticipants(tmp_arr)
}

return (<>
<Listbox emptyContent='No Participants' selectedKeys={[]} items={participants} label="Participants" selectionMode="multiple" variant="flat" 
    classNames={{
        base: "rounded-xl bg-white shadow-sm dark:border-default-200 dark:bg-content1",
        list: "max-h-[500px] overflow-auto",
    }}>
    {(item) => (
        <ListboxItem key={item.id} textValue={item.fullname} className="hover:bg-neutral-100 dark:hover:bg-default-100">
        <div className="flex items-center gap-3">
            <Avatar size="sm" src={`https://api.dicebear.com/9.x/thumbs/svg?seed=${encodeURIComponent(item.fullname || String(item.id))}`}/>
            <div className="flex flex-col">
                <span className="text-sm font-medium text-neutral-800 dark:text-foreground capitalize">
                    {item.fullname}
                </span>
                <span className="text-xs text-neutral-600 dark:text-default-500">
                    {item.email_address}
                </span>
            </div>
        </div>
        </ListboxItem>
    )}
</Listbox>
</>)
}

export default MeetsMembersComp